import { createSignal } from 'solid-js';
import { createMagicDoorContext } from '~/contexts/utils';
import { WorkOrderSettingsRepository } from '~/repositories/settings/workOrderSettingsRepository';
import type { WorkOrderSettings, WorkOrderSettingsCompanyPortalTypedSettingsWithOverridesDocument } from '~/swagger/settings/Api';
export const [WorkOrderSettingsProvider, useWorkOrderSettings] = createMagicDoorContext('WorkOrderSettings', () => {
  const repo = new WorkOrderSettingsRepository();
  const [isLoading, setIsLoading] = createSignal(false);
  const [error, setError] = createSignal<Error | undefined>(undefined);
  const [allWorkOrderSettings, setAllWorkOrderSettings] = createSignal<
    WorkOrderSettingsCompanyPortalTypedSettingsWithOverridesDocument | undefined
  >();

  const getAllWorkOrderSettings = async () => {
    try {
      setIsLoading(true);
      const json = await repo.getAllWorkOrderSettings();
      setAllWorkOrderSettings(json);
    } catch (err) {
      setError(err instanceof Error ? err : new Error(String(err)));
    } finally {
      setIsLoading(false);
    }
  };

  const updateWorkOrderSettings = async (payload: WorkOrderSettings) => {
    try {
      setIsLoading(true);
      await repo.updateWorkOrderSettings(payload);
    } catch (err) {
      setError(err instanceof Error ? err : new Error(String(err)));
    } finally {
      setIsLoading(false);
    }
  };

  const updateOverrideWorkOrderSettings = async (level: string, levelId: string, payload: WorkOrderSettings) => {
    try {
      setIsLoading(true);
      await repo.updateOverrideWorkOrderSettings(level, levelId, payload);
    } catch (err) {
      setError(err instanceof Error ? err : new Error(String(err)));
    } finally {
      setIsLoading(false);
    }
  };

  const addOverrideSettings = async (level: string, levelId: string, payload: WorkOrderSettings) => {
    try {
      setIsLoading(true);
      await repo.addOverrideSettings(level, levelId, payload);
    } catch (err) {
      setError(err instanceof Error ? err : new Error(String(err)));
    } finally {
      setIsLoading(false);
    }
  };

  const removeOverrideSettings = async (level: string, levelId: string) => {
    try {
      setIsLoading(true);
      await repo.removeOverrideSettings(level, levelId);
    } catch (err) {
      setError(err instanceof Error ? err : new Error(String(err)));
    } finally {
      setIsLoading(false);
    }
  };

  return {
    error,
    isLoading,
    allWorkOrderSettings,
    getAllWorkOrderSettings,
    updateWorkOrderSettings,
    addOverrideSettings,
    updateOverrideWorkOrderSettings,
    removeOverrideSettings,
  };
});
